import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "grid mb-2" }
const _hoisted_3 = { class: "col-12 lg:col-6" }
const _hoisted_4 = { class: "col-12 lg:col-6" }
const _hoisted_5 = { class: "grid grid-nogutter" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "field-checkbox" }
const _hoisted_8 = ["for"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Time targeting is set due to the time zone of the geo campaign is set on", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_PrimeVueCheckbox = _resolveComponent("PrimeVueCheckbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('schedule_by_hours')), 1),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default"),
      (!_ctx.hideSchedule)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_PrimeVueButton, {
                  class: "p-button-outlined w-full",
                  label: _ctx.$t('select_all'),
                  onClick: _ctx.selectAll
                }, null, 8, ["label", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_PrimeVueButton, {
                  class: "p-button-outlined w-full",
                  label: _ctx.$t('unselect_all'),
                  onClick: _ctx.unselectAll
                }, null, 8, ["label", "onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (_, index) => {
                return _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_PrimeVueCheckbox, {
                      modelValue: _ctx.schedule,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.schedule) = $event)),
                      value: index,
                      id: `hour_${index}`,
                      class: _normalizeClass({ 'p-invalid': !_ctx.schedule.length })
                    }, null, 8, ["modelValue", "value", "id", "class"]),
                    _createElementVNode("label", {
                      for: `hour_${index}`
                    }, _toDisplayString(index.toString().padStart(2, '0')) + ":00", 9, _hoisted_8)
                  ])
                ])
              }), 64))
            ]),
            _hoisted_9
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}